export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_MICROSOFT_CLIENT_ID}`,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `/`,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Calendars.ReadWrite"],
};

// Kept separate from loginRequest so the everyday Teams flows are not blocked
// behind a scope that needs one-off admin consent. Reading a meeting transcript
// also needs Calendars.Read, because crm_calls.teams_id is a calendar event id,
// and OnlineMeetings.Read to resolve the event's join URL to the meeting.
export const transcriptRequest = {
  scopes: [
    "User.Read",
    "Calendars.Read",
    "OnlineMeetings.Read",
    "OnlineMeetingTranscript.Read.All",
  ],
};
